import { NumberFormatBase } from 'react-number-format';
import TextField from '../TextField';
import { INumericTextFieldBaseProps } from '../NumericTextField';

const FIRST_MONTH = '01';
const LAST_MONTH = '12';

export interface IExpiryDateTextFieldProps extends INumericTextFieldBaseProps {}

const formatExpiryDate = (val: string) => {
  if (val === '') return '';
  let month = val.substring(0, 2);
  const year = val.substring(2, 6);
  if (month.length === 1 && Number(month[0]) > 1) {
    month = `0${month[0]}`;
  } else if (month.length === 2) {
    if (Number(month) === 0) {
      month = FIRST_MONTH;
    } else if (Number(month) > Number(LAST_MONTH)) {
      month = LAST_MONTH;
    }
  }
  return `${month}/${year}`;
};

const ExpiryDateTextField = (props: IExpiryDateTextFieldProps) => (
  <NumberFormatBase
    customInput={TextField}
    format={formatExpiryDate}
    {...props}
  />
);

export default ExpiryDateTextField;
